import React, { useState, useContext, createContext } from 'react';
import { OverflowMenu, styled } from '@ui-kitten/components';
import { DNABox, DNACard, DNAConditionalWrapper, DNAText, DNAIcon, Iffy, Popover, util, } from "../../../index";
import findChildren from "../../../util/findChildren";
export var DNAContextMenuAppearanceEnum;
(function (DNAContextMenuAppearanceEnum) {
    DNAContextMenuAppearanceEnum["default"] = "default";
})(DNAContextMenuAppearanceEnum || (DNAContextMenuAppearanceEnum = {}));
export const DNAContextMenuAppearanceKeys = Object.keys(DNAContextMenuAppearanceEnum);
export const DNAContextMenuContext = createContext(() => { });
function parseThemeStyle(source) {
    const { customAttr, ...container } = source;
    return {
        container,
        customStyle: {
            customAttr,
        },
    };
}
export const DNAContextMenu = (props) => {
    const { eva, children, ...rest } = props;
    const [isVisible, setIsVisible] = useState(false);
    const themeStyles = parseThemeStyle(eva?.style);
    const containerStyle = util.mergeStyles(props, themeStyles.container);
    const [[anchorChild], , restChildren] = findChildren(DNAContextMenuAnchor, children);
    const [[itemsChild]] = findChildren(DNAContextMenuItems, restChildren);
    const [itemChildren] = findChildren(DNAContextMenuItem, itemsChild?.props?.children || []);
    const moddedAnchorChild = React.cloneElement(anchorChild.props.children, {
        onPress: () => {
            anchorChild?.props?.children?.props?.onPress?.();
            setIsVisible(true);
        },
    });
    return (
    // @ts-ignore
    <OverflowMenu visible={isVisible} style={containerStyle} {...rest} 
    // @ts-ignore
    anchor={() => moddedAnchorChild} onBackdropPress={() => setIsVisible(false)}>
      <DNAContextMenuContext.Provider value={setIsVisible}>
        {itemChildren}
      </DNAContextMenuContext.Provider>
    </OverflowMenu>);
};
export const DNAContextMenuAnchor = (props) => {
    const { children } = props;
    return children;
};
export const DNAContextMenuItems = (props) => {
    const { children } = props;
    return children;
};
export const DNAContextMenuItem = (props) => {
    const { title, collapseOnPress = true, icon, onPress, delay = 0, children, status = 'primary', iconStatus = 'secondary', childrenWrapper, minWidth, CustomIcon, popoverText, disablePopover, } = props;
    const setIsVisible = useContext(DNAContextMenuContext);
    const wrappedOnPress = () => {
        if (collapseOnPress)
            setIsVisible(false);
        setTimeout(onPress, delay);
    };
    if (children) {
        return children;
    }
    const renderedItem = (<DNACard interactive="pressable" appearance="flat" onPress={wrappedOnPress} testID={`context-menu-row-${title?.toLocaleLowerCase().replaceAll(' ', '-')}`}>
      <DNAConditionalWrapper condition={popoverText && !disablePopover} wrapper={children => (<Popover disablePopover={disablePopover}>
            <Popover.Anchor>
              {children}
            </Popover.Anchor>
            <Popover.Content>
              <DNAText colorMode='dark' style={{ width: 400 }}>
                {popoverText}
              </DNAText>
            </Popover.Content>
          </Popover>)}>
        <DNABox alignY="center" spacing="sm" style={[{ paddingVertical: 12, paddingHorizontal: 24 }, minWidth ? { minWidth } : {}]}>
          <Iffy is={CustomIcon}>
            <DNAIcon.Styled status={iconStatus} size="sm" CustomIcon={CustomIcon}/>
          </Iffy>
          <Iffy is={icon && typeof icon === 'string'}>
            <DNAIcon.Styled name={icon} status={iconStatus} size="sm"/>
          </Iffy>
          <Iffy is={icon && typeof icon !== 'string'}>
            {icon}
          </Iffy>
          <DNAText testID="context-menu-row-label" status={status}>
            {title}
          </DNAText>
        </DNABox>
      </DNAConditionalWrapper>
    </DNACard>);
    return childrenWrapper
        ? childrenWrapper(renderedItem)
        : renderedItem;
};
DNAContextMenu.displayName = 'DNAContextMenu';
DNAContextMenuAnchor.displayName = 'DNAContextMenuAnchor';
DNAContextMenuItems.displayName = 'DNAContextMenuItems';
DNAContextMenuItem.displayName = 'DNAContextMenuItem';
DNAContextMenu.Anchor = DNAContextMenuAnchor;
DNAContextMenu.Items = DNAContextMenuItems;
DNAContextMenu.Item = DNAContextMenuItem;
// [TODO]: Allow Styled type to handle compound components
export default styled('DNAContextMenu')(DNAContextMenu);
//# sourceMappingURL=DNAContextMenu.js.map